<nz-input-group nz-input nzSize="large" [nzPrefix]="currency() | currencySymbol" [nzStatus]="status()">
    <input
        nz-input
        type="text"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [ngModel]="displayInput() | number: '0.0-2' : locale() | lowercase"
        (ngModelChange)="emit($event)"
    />
</nz-input-group>

@if (!!status() && !!limits()) {
    <div class="ant-form-item-explain-error label-2 a-text-left">
        {{ 'common.please-enter-valun-in-range' | translate }}<br />{{ currency() | currencySymbol }}
        {{ limits().min }} - {{ limits().max }}
    </div>
}
